import { FaTaxi } from 'react-icons/fa6';
import { images } from '../constants';

const pricing = [
    {
        id: 1,
        image: images.plan1,
        icon: <FaTaxi />, 
        title: 'Basic Package',
        price: 15.00,
        list: [
            'City Rides',
            'Up to 10 Miles',
            '24/7 Availability',
            'Standard Vehicle',
            'No Hidden Fees',
        ],
    },
    {  
        id: 2, 
        image: images.plan2,
        icon: <FaTaxi />, 
        title: 'Standard Package',
        price: 25.00,
        list: [
            'City Rides',
            'Up to 20 Miles',
            'Priority Support',
            'Luxury Vehicle',
            'Complimentary Water',
        ],
    },
    {  
        id: 3,
        image: images.plan3,
        icon: <FaTaxi />, 
        title: 'Premium Package',
        price: 40.00,
        list: [
            'City & Airport Rides',
            'Up to 30 Miles',
            'VIP Support',
            'Premium Vehicle',
            'Complimentary Snacks',
        ],
    },
];

export default pricing;